import { registerPopup } from './accounts-popup';

registerPopup();
